import { useRouter } from "next/router";
// BOOTSTRAP
import Tooltip from "react-bootstrap/Tooltip";
import { useApp } from "@/components/context/AppContext/AppContext";
import fallbackTranslation from "@/lib/dbTranslations";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useTranslation } from "next-i18next";
// STYLE
import s from "./SquareColorSelector.module.scss";

interface SquareColorSelector {
  color: string;
  tooltipText?: boolean;
  index: any;
  placement: any;
  square_size: string;
  selected?: any;
}

export default function SquareColorSelector({ color, tooltipText = false, index, placement, square_size, selected }: SquareColorSelector) {
  const app = useApp();
  const router = useRouter();
  const { t } = useTranslation("db-translations");

  let selectedColor = "";
  if (selected) {
    selectedColor = selected.trim().replace(" ", "");
  }

  const colorObj = app.appConfig?.colors && app.appConfig?.colors.find((el) => el?.key == color);

  return (
    <>
      {tooltipText ? (
        <OverlayTrigger
          placement={placement}
          delay={{ show: 150, hide: 0 }}
          overlay={
            <Tooltip id={color}>
              {fallbackTranslation("colors", "db-translations", colorObj, t, router.locale || "it") || t("common.not-found")}
            </Tooltip>
          }
          key={index}
        >
          <div
            className={`${square_size} ${s.square}`}
            style={{ backgroundColor: colorObj?.value, outline: selectedColor == colorObj?.key ? "4px #A0A2A4 solid" : "none" }}
          ></div>
        </OverlayTrigger>
      ) : (
        <div
          className={`${square_size}`}
          style={{
            border: "1px solid",
            borderColor: "black",
            backgroundColor: colorObj?.value,
            outline: selectedColor == colorObj?.key ? "4px #A0A2A4 solid" : "none",
          }}
        ></div>
      )}
    </>
  );
}
